import { render, staticRenderFns } from "./diagnostic.vue?vue&type=template&id=31d97ef2&scoped=true&"
import script from "./diagnostic.vue?vue&type=script&lang=js&"
export * from "./diagnostic.vue?vue&type=script&lang=js&"
import style0 from "./diagnostic.vue?vue&type=style&index=0&id=31d97ef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d97ef2",
  null
  
)

export default component.exports